import { render, staticRenderFns } from "./SectionLoanSummary.vue?vue&type=template&id=d32fba5c&scoped=true&"
import script from "./SectionLoanSummary.vue?vue&type=script&lang=js&"
export * from "./SectionLoanSummary.vue?vue&type=script&lang=js&"
import style0 from "./SectionLoanSummary.vue?vue&type=style&index=0&id=d32fba5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32fba5c",
  null
  
)

export default component.exports